<template>
  <b-field>
    <p class="control">
      <b-dropdown>
        <button type="button" class="button" slot="trigger">
          <span>{{$tc('dropdown.filters')}}</span>
          <b-icon icon="menu-down"></b-icon>
        </button>

        <div class="dropdown-item" style="width: 300px;">
          <b-field :label="$tc('dropdown.language')">
            <b-select v-model="filters.locale" expanded>
              <option :value="key" v-for="(label, key) in languages" :key="key">
                {{
                  label
                }}
              </option>
            </b-select>
          </b-field>
        </div>
      </b-dropdown>
    </p>

    <b-input :placeholder="$tc('dater.range')"
             @blur="searchChanged()"
             v-model="filters.search"
             type="search"
             icon="magnify"
             icon-clickable
             expanded
    ></b-input>

    <div class="control">
      <button type="reset" class="button" @click="reset">
        <b-icon icon="close"></b-icon>
        <span>{{$tc('reset')}}</span>
      </button>
    </div>
  </b-field>
</template>

<script>
import {getActiveLanguages} from "@/data/languages";

export default {
  data() {
    let languages = getActiveLanguages();
    return {
      filters: this.default(),
      languages
    };
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.$emit("input", this.filters);
      }
    }
  },

  methods: {
    reset() {
      this.filters = this.default();
      this.filters.search = '';
      localStorage.setItem('feed-search', '')
    },

    default() {
      return {
        locale: null,
        search: localStorage.getItem('feed-search') || ''
      };
    },

    searchChanged(){
      localStorage.setItem('feed-search', this.filters.search);
    }
  }
};
</script>
